import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83052352"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clasificacion-select" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ⮞ ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ⮟ ")
const _hoisted_6 = { class: "descripcion" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClasificacionSelect = _resolveComponent("ClasificacionSelect", true)!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clasificaciones, (clas, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: clas.codigo,
        onClick: _withModifiers(($event: any) => (_ctx.selectClasificacion(clas)), ["stop"])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([{ selected: clas.codigo === _ctx.modelValue?.codigo }, "option"])
        }, [
          (clas.hijos?.length ?? 0 > 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "toggler",
                onClick: _withModifiers(($event: any) => (_ctx.toggleCollapsed(index)), ["stop"])
              }, [
                (_ctx.collapsed[index])
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_4
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_5
                    ], 64))
              ], 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_6, _toDisplayString(clas.descripcion), 1)
        ], 2),
        (clas.hijos && !_ctx.collapsed[index])
          ? (_openBlock(), _createBlock(_component_ClasificacionSelect, {
              key: 0,
              clasificaciones: clas.hijos,
              "onUpdate:modelValue": _ctx.selectedChild,
              "model-value": _ctx.selectedValue
            }, null, 8, ["clasificaciones", "onUpdate:modelValue", "model-value"]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}